import Onjn from '../assets/onjn.png'
import Adult from '../assets/18+.png'
import TrackingLink from "./TrackingLink";

export const Footer = ({isPrincessAgent}) => {
    return (
        <footer>
            <div className="links">
                <TrackingLink href="https://www.princesscasino.ro/about-us" target="_blank">Despre noi</TrackingLink>
                <TrackingLink href="https://www.princesscasino.ro/privacy-policy" target="_blank">Politica de confidentialitate</TrackingLink>
                <TrackingLink href="https://www.princesscasino.ro/responsible-gambling" target="_blank">Joc responsabil</TrackingLink>
                <TrackingLink href="https://www.princesscasino.ro/terms-conditions" target="_blank">Termeni si conditii</TrackingLink>
                <TrackingLink href="https://www.princesscasino.ro/faq" target="_blank">Intrebari frecvente</TrackingLink>
                <TrackingLink href="https://www.princesscasino.ro/support" target="_blank">Contact</TrackingLink>
            </div>
            <div className="text">
                <div>
                    <p>
                        Site-ul Princess Casino este deținut și operat de către Crowd Entertainment Limited, societate
                        înmatriculată conform legii societăţilor comerciale din Malta, cu sediul social în 2 Spinola
                        Road, St. J
                        ulians STJ 3014, Malta, număr de înregistrare C97517. Licența nr. L1213823W001269, emisă de
                        Comitetul de
                        Supraveghere din cadrul O.N.J.N., valabilă din data de 01.03.2021 până la data de 28.02.2031.
                    </p>
                    <p>
                        Cod unic de identificare fiscală 43557448, eliberat de Administrația Fiscală pentru
                        Contribuabili
                        Nerezidenți. Accesul la site-urile online cu jocuri pe bani reali este interzis în conformitate
                        cu un
                        ele legislații naționale. Este responsabilitatea fiecărui jucător în parte de a se asigura că
                        acționează
                        în conformitate cu legislația în vigoare atunci când accesează site-ul Princess Casino.
                    </p>
                    <p>
                        Jocurile de noroc implică riscuri financiare și de dependență. Jucați cu moderație.
                    </p>
                </div>
                <div>
                    <img src={Onjn} alt="onjn"/>
                    <img src={Adult} alt="18+"/>
                </div>
            </div>
            <div className="cookies">
                <p>Acest site folosește cookie-uri. Prin utilizarea acestui site confirmi că ești de acord cu folosirea
                    cookie-urilor. {!isPrincessAgent && <TrackingLink href="https://www.princesscasino.ro/privacy-policy" target="_blank"
                                                  rel="noreferrer">Mai multe
                        detalii
                        aici.</TrackingLink>}</p>
            </div>
            <div className="win-at-princess">
                <h2>CÂȘTIGĂ LA PRINCESS CASINO CU PÂNĂ LA 710 ROTIRI GRATUITE ȘI 2000 RON BONUS DE BUN VENIT ȘI CU CELE MAI
                    MULTE JOCURI
                    DE CASINO ONLINE</h2>
                <div className="content">
                    <div className="content-section">
                        <h3>Bun venit în cel mai nou casino online</h3>
                        <p>Știm că ați mai jucat la alte casinouri online, dar avem convingerea că, odată ce ați trecut
                            prin
                            experiența unui adevărat casino de top, nu veți mai vrea să priviți în spate. La Princess
                            Casino,
                            suntem cu un pas înaintea celorlalți: garantăm cele mai variate sloturi și cele mai bune
                            jocuri de
                            masă, cele mai mari bonusuri, cel mai eficient suport clienți și cele mai rapide depuneri și
                            retrageri, în deplină siguranță.</p>
                        <p>Suntem la început, dar nu începători. Avem în spate o echipă de specialiști formați atât în
                            casinouri
                            online de top, cât și în lumea casinourilor terestre. Știm cât de important este pentru
                            jucători să
                            fie tratați cu respect și corectitudine, dar să se și distreze. De asemenea, față de alte
                            casinouri
                            online noi, cunoaștem suficient de bine piața cât să reușim să îi surprindem chiar și pe cei
                            mai
                            versați jucători. De aceea, venim cu cele mai bune promoții la casino live sau online,
                            aducem
                            sloturile cu cele mai mari jackpoturi de pe piață și promitem să nu vă amăgim cu bonusuri
                            prea bune
                            să fie adevărate.</p>
                        <h3 className="secondSectionTitle">Testați Princess Casino cu un bonus fara depunere</h3>
                        <p>Jocurile păcănele pot fi doar distracție, fără niciun risc. Încercați-vă șansa și testați
                            atmosfera
                            din cel mai bun casino nou din România cu bonusul fără depunere oferit de Princess Casino.
                            De
                            asemenea, sloturile online din oferta noastră pot fi jucate și în varianta Play Money:
                            aveți,
                            astfel, control complet asupra deciziei de a trece la următorul nivel - jocuri casino pe
                            bani
                            reali.</p>
                        <p>Pe lângă oferta de bonusuri de bun venit fara depunere, am conceput un pachet de oferte
                            pentru
                            fiecare dintre cei care vor să încerce experiența Princess Casino.</p>
                        <p>Astfel, pentru primul dvs. depozit beneficiați de un cadou de 800 RON, urmat de alte oferte
                            care
                            promitem să vă țină conectat la distracție. Intrați pe pagina de promoții sau urmăriți-ne pe
                            rețelele de socializare pentru a afla despre campaniile noastre de bonus la depunere,
                            jackpoturi și
                            runde gratuite la cele mai captivante jocuri.</p>
                    </div>
                    <div className="content-section">
                        <h3>Ofertă completă de jocuri casino</h3>
                        <p>Ne-am dezvoltat pe o platformă de casino de ultimă generație, ce ne permite să venim în
                            întâmpinarea
                            jucătorilor noștri cu un meniu personalizat. La Princess Casino, nu trebuie să pierdeți
                            timpul
                            căutând prin sute de sloturi, ci le veți avea permanent la un click distanță, fie că doriți
                            să
                            navigați ușor de la un joc la altul, aveți nevoie de sugestii de jocuri în funcție de
                            gusturile dvs.
                            sau vă doriți să aveți tot timpul la îndemână istoricul de sloturi jucate.</p>
                        <p>Avem un portofoliu de aproape o mie de jocuri slot, alese pe sprânceană. Odată înregistrat la
                            Princess Casino, vă veți putea bucura de jocuri de casino noi de la provideri precumEGT,
                            Greentube,
                            Play'n go sau Pragmatic Play, recunoscuți pentru sloturile cu castiguri mari. Avem grijă să
                            ne
                            actualizăm permanent portofoliul, fie că e vorba de jocuri ca la aparate, jocuri de masă,
                            jocuri cu
                            jackpoturi și jackpoturi progresive sau de jocuri de casino live. Vă așteptăm la orice oră
                            în
                            Princess Casino și oferim la schimb amuzament, adrenalină și fairplay.</p>
                        <p>Casinoul online Princess este la fel de mobil ca și dvs. – exact sloturile pe care le-ați
                            juca
                            într-un casino online sau într-unul fizic vin pe telefonul dvs.: la fel de variate, la fel
                            de
                            distractive, la fel de profitabile. La fel de bine, puteți juca de pe mobil jocuri de casino
                            live.
                            Lucrăm cu doi furnizori de live casino, ce transmit în timp real din studiouri care asigură
                            o
                            experiență similară celei din casinourile clasice, indiferent de dispozitivul de pe care
                            decideți să
                            jucați.</p>
                    </div>
                    <div className="content-section">
                        <h3>Jocuri de cazino cu jackpoturi mari și câștiguri rapide</h3>
                        <p>Deși sunt peste 20 de casinouri legale în România, încă nu știți care este cel mai bun casino
                            online?
                            Sperăm să vă convingem cu <strong>bonusul fără depunere oferit la înregistrare</strong>, dar
                            si cu
                            colecția noastră
                            de jackpoturi și jackpoturi progresive.</p>
                        <p>Sume mari, ce pot schimba viața oricărui jucător, și ce pot fi câștigate la orice oră din zi
                            și din
                            noapte, în timpul oricărei runde, la unele dintre cele mai populare sloturi clasice (precum
                            Shining
                            Crown sau Book of Ra) sau cu temă modernă (Super Flip sau Star Joker), dar și la jocuri de
                            masă
                            precum Rouleta sau Blackjack.</p>
                        <p>Știm că toate casinourile vă promit depuneri și retrageri rapide, dar noi ducem tranzacțiile
                            rapide
                            la alt nivel și avem grijă să vă oferim cele mai eficiente metode de depunere și retragere.
                            Practic,
                            asigurând plăți aproape instante, eliminăm această problemă din experiența dvs. de
                            casino.</p>
                        <p>Seria veștilor bune continuă cu programul de loialitate al casinoului online Princess, prin
                            care ne
                            răsplătim jucătorii fideli – și nu numai: mai multe detalii despre cum toți utilizatorii
                            noștri pot
                            beneficia de acest sistem de bonusare, aici.</p>
                        <h3 className="secondSectionTitle">Casino legal, securitate garantată</h3>
                        <p>Platforma noastră de online casino garantează jucătorilor o experiență prietenoasă și fără
                            probleme
                            de securitate, îndeplinind cele mai înalte cerințe ale autorităților specializate în
                            reglementarea
                            site-urilor de jocuri de noroc online. Fiind un domeniu sensibil, în care utilizatorii ne
                            încredințează date importante, atât personale cât și financiare, ne-am preocupat să
                            identificăm și
                            să implementăm cele mai bune tehnologii de criptare disponibile la nivel mondial.</p>
                        <p>În lumea Princess Casino, credem că dacă te joci mai des, este pentru că vrei să te distrezi
                            și să te
                            bucuri de premii surprinzătoare. Pentru jucătorii care simt că au depășit această limită,
                            punem la
                            dispoziție un set de instrumente menite să limiteze jocul compulsiv în casino online.
                            Aceștia pot
                            oricând să își suspende contul de jucător, pentru o perioadă anume sau chiar definitiv, își
                            pot seta
                            limite pe timpul de joc, mize sau depuneri și pierderi, iar platforma noastră are
                            posibilitatea de a
                            detecta și a semnala comportamentele de joc neadecvate.</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}